import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import SystemHub from './pages/hub/SystemHub';
import UserManagement from './pages/admin/UserManagement';
import ProfileManagement from './pages/admin/ProfileManagement';
import SystemManagement from './pages/admin/SystemManagement';
import PermissionManagement from './pages/admin/PermissionManagement';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Rota de Login */}
      <Route path="/login" element={<LoginPage />} />
      
      {/* Rota Raiz - Redireciona para Hub */}
      <Route path="/" element={
        <ProtectedRoute>
          <Navigate to="/hub" replace />
        </ProtectedRoute>
      } />
      
      {/* Hub de Sistemas */}
      <Route path="/hub" element={
        <ProtectedRoute>
          <SystemHub />
        </ProtectedRoute>
      } />
      
      {/* Administração de Usuários */}
      <Route path="/admin/users" element={
        <ProtectedRoute requiresAdmin={true}>
          <UserManagement />
        </ProtectedRoute>
      } />
      
      {/* Administração de Perfis */}
      <Route path="/admin/profiles" element={
        <ProtectedRoute requiresAdmin={true}>
          <ProfileManagement />
        </ProtectedRoute>
      } />
      
      {/* Administração de Sistemas */}
      <Route path="/admin/systems" element={
        <ProtectedRoute requiresAdmin={true}>
          <SystemManagement />
        </ProtectedRoute>
      } />
      
      {/* Administração de Permissões */}
      <Route path="/admin/permissions" element={
        <ProtectedRoute requiresAdmin={true}>
          <PermissionManagement />
        </ProtectedRoute>
      } />
      
      {/* Rota para páginas não encontradas */}
      <Route path="*" element={
        <ProtectedRoute>
          <Navigate to="/hub" replace />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default AppRoutes;